import { ICreateProductsQrDTO, IProductsQrType } from '@/models/generateQr.model';
import { TGenerateQrFormValues, GenerateQrFields } from '../helpers';

class CreateProductQrDTO implements ICreateProductsQrDTO {
  type?: IProductsQrType;
  region_id?: string;
  categories?: string[];
  stores?: string[];
  products?: string[];

  constructor(values: TGenerateQrFormValues) {
    this.type = values[GenerateQrFields.TYPE];
    this.region_id = values[GenerateQrFields.REGION_ID];

    if (values[GenerateQrFields.CATEGORIES]) {
      this.categories = values[GenerateQrFields.CATEGORIES];
    }
    if (values[GenerateQrFields.STORES]) {
      this.stores = values[GenerateQrFields.STORES];
    }
    if (values[GenerateQrFields.PRODUCTS]) {
      this.products = values[GenerateQrFields.PRODUCTS];
    }
  }
}

export default CreateProductQrDTO;
